import { Grid, Typography, lighten, styled } from "@mui/material";

export const TravelExpenseWrapper = styled(Grid)({
  position: "relative",
  padding: "4px",

  "&:hover > .delete_button": {
    display: "block",
  },
});

export const TravelExpenseContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "auditAccepted",
})<{ auditAccepted?: boolean | null }>(({ theme }) => ({
  boxShadow: theme.shadows[3],
  minWidth: "fit-content",
  width: "100%",
  // minHeight: "130px",
  // borderRadius: "5px",
  // padding: "10px",
  display: "flex",
  // flexDirection: "column",
  // gap: "10px",
  justifyContent: "space-between",
  "& > .MuiGrid-root": {
    "&:not(:nth-of-type(2))": {
      padding: "25px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    "&:nth-of-type(2)": {
      padding: "25px 0px",
    },
  },
}));

export const MainInfoContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "highlight",
})<{ highlight: boolean }>(({ highlight, theme }) => ({
  ...(highlight && {
    backgroundColor: lighten(theme.palette.error.main, 0.9),
  }),
}));

export const DescriptionBlock = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "flex-start",
});

export const AmountBlock = styled(Grid)({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  alignItems: "flex-end",
  justifyContent: "space-between",
});

export const NotesInfoContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
  justifyContent: "center",
  width: "100%",
});

export const IconTextContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  gap: "5px",
  alignItems: "center",
});

export const FlagIconContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  // alignItems: "center",
  justifyContent: "center",
});

export const AmountsContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

export const AmountRow = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",
  justifyContent: "space-between",
});

export const AmountsTitleContainer = styled(Grid)({
  width: "140px",
});

export const AmountTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.disabled,
}));

export const Amounts = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "aceeptedAmount",
})<{ aceeptedAmount?: boolean }>(
  ({ theme }) => ({
    fontWeight: "bold",
    textTransform: "uppercase",
    maxWidth: "300px",
    overflow: "hidden",
    textOverflow: "ellipsis",
  }),
  ({ aceeptedAmount, theme }) => ({
    ...(!!aceeptedAmount && {
      color: theme.palette.success.main,
    }),
  })
);

export const DataContainer = styled(Grid)({
  width: "100%",
  height: "100%",
  minWidth: "600px",
  display: "flex",
  flexDirection: "row",
  flexWrap: "nowrap",

  "& > div,hr": {
    marginRight: "10px",
  },

  "& > div:last-child": {
    marginRight: "0px",
  },
});

export const ReceiptStatusContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "5px",
});

export const StatusFlagContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "auditAccepted",
})<{ auditAccepted: boolean | null }>(
  {
    display: "flex",
    flexDirection: "column",
    height: "auto",
    flex: 1,
    flexGrow: 1,
    alignItems: "center",
    justifyContent: "center",
    width: "130px",
    maxWidth: "130px",
    gap: "10px",
  },
  ({ auditAccepted, theme }) => ({
    ...(auditAccepted === null && {
      backgroundColor: theme.palette.background.paper,
    }),
    ...(auditAccepted === true && {
      backgroundColor: lighten(theme.palette.success.main, 0.8),
    }),
    ...(auditAccepted === false && {
      backgroundColor: lighten(theme.palette.error.main, 0.9),
    }),
  })
);
